import React, { useEffect, useRef, useState } from 'react';
import { getFetch } from '../../fetch/fetch';
import { addZeroIfOne } from '../../dashboard/components/controls/etc/etcfunctions';
import styles from "./mobilemycoaching.module.css";
import { CircularProgress } from '@mui/joy';
import { useHistory } from 'react-router-dom';
import { coachFormIdData } from './forms/formsiddata/coachform';

const MobileSelectCoach: React.FC<any> = (props) => {

    const [contents, setContents] = useState<any[]>([]);
    const [height, setHeight] = useState(0);
    const [loading, setLoading] = useState(false);
    const history = useHistory();
    const [teachers, setTeachers] = useState<any[]>([]);


    useEffect(() => {
        const handleResize = () => {
            const newHeight = Math.floor((window.innerWidth * 447) / 1080);
            setHeight(newHeight);
        };

        // 처음 마운트될 때 한 번 실행
        handleResize();

        // 윈도우 리사이즈 이벤트 등록
        window.addEventListener('resize', handleResize);

        // 언마운트 시 이벤트 제거
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);



    useEffect(() => {

        getCoachList();

    }, []);

    const getCoachList = async () => {

        try {

            setLoading(true);

            const result: any = await getFetch("/dashboard/mycoach/getcoachlist");
            console.log(result);

            if (result.message !== "success") {
                return;
            }

            const data = result.data;

            const teachers : any = [];

            data.forEach((item : any) => {
                const oneTeacher : any = {}
                const questions = item.questions;

                oneTeacher.userId = item.userId;

                questions.forEach((question: any) => {

                    Object.entries(coachFormIdData).forEach(([key, value]) => {
                        if (question.id === value) {
                            oneTeacher[key] = {};
                            oneTeacher[key].id = question.id;
                            oneTeacher[key].value = question.value;
                            oneTeacher[key].type = question.type;
                        }
                    });

                });

                teachers.push(oneTeacher);
            })

            console.log(teachers);

            setTeachers([...teachers]);

        
            setLoading(false);


        } catch (e) {
            console.error(e);
        }

    }



    return (
        <div style={{
            display: "flex",
            flexWrap: "wrap",
            width: "90.4%",
            margin: "0 auto",
            justifyContent: "space-between",
            overflowY: "auto",
            paddingBottom: "1rem",
        }}
            className={styles.body}
        >
            {
                !loading ? teachers.map((teacher, index) => {

                    return (
                        <div key={index} style={{
                            width: `${height}px`,
                            marginBottom: "1.4rem",
                        }}
                            onClick={() => {
                                history.push({
                                    pathname: "/mobiledashboard/teacherdetail",
                                    state: { teacher }
                                })
                            }}
                        >
                            <div style={{
                                width: "100%",
                                height: `${height}px`,
                                overflow: "hidden",
                                borderRadius: "0.5rem",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                position: "relative",
                            }}>
                                <img src={
                                    teacher?.profilePicture?.value[0]?.url
                                } alt="content" style={{
                                    width: "100%",
                                    borderRadius: "0.5rem",
                                }} />
                                <div style={{
                                    position : "absolute",
                                    top : "9px",
                                    left : "9px",
                                    width : "0.6rem",
                                    height : "0.6rem",
                                    borderRadius: "50%",
                                    backgroundColor : teacher?.isAvailable?.value ? "#1ce223" : "#ff1e00"
                                }}  />
                            </div>
                            <div style={{
                                marginTop: "0.4rem",
                            }}>
                                <div style={{
                                    fontFamily: "Apple_B",
                                    fontSize: "1rem",
                                    letterSpacing: "-0.5px",
                                    lineHeight: "1.2",
                                }}>
                                    <span>{teacher.nickName?.value}</span>
                                    <span
                                    style={{
                                        marginLeft: "0.2rem",
                                        fontFamily: "Apple_L",
                                        fontSize : "0.75rem"
                                    }}
                                    >{teacher.schoolName?.value} {teacher.departmentName.value}</span>
                                </div>
                                {/* <div style={{
                                    marginTop: "0.2rem",
                                    fontFamily: "Apple_M",
                                    color: "#6B7583"
                                }}>
                                    123
                                </div> */}
                                <div style={{
                                    fontFamily: "Apple_L",
                                    color: "#6B7583",
                                    marginTop: "0.15rem",
                                    fontSize: "0.7rem",
                                }}>
                                    {teacher.introduceLine?.value}
                                </div>
                            </div>
                        </div>
                    )

                })
                    :
                    ""
            }
            {
                loading ?
                    <div style={{
                        width: "100%",
                        height: `${props.statusDivHeight}px`,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                    }}>
                        <CircularProgress />
                    </div>
                    :
                    ""
            }
        </div>
    )

};

export default MobileSelectCoach;